import styled from 'styled-components'

import blockIcon from '../../assets/icons/block.svg'

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #1E8B98;
  border-radius: 5px;
  max-width: 350px;

  @media screen and (max-width: 360px) {
    margin: 0 -15px;
  }
`

export const Navbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;
  height: 65px;
  margin: 0 7px;
`

export const Cell = styled.div`
  height: 50px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${props => props.opaque && 'opacity: 0.5;'}
`

export const DateText = styled.div`
  color: white;
  align-self: flex-start;
  font-weight: 600;
  padding-left: 3px;
`

export const BadgeList = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
`

export const Badge = styled.div`
  border-radius: 50%;
  color: white;
  font-weight: bold;
  background-color: #FF8300;
  align-self: flex-start;
  width: 21px;
  height: 21px;
  ${props => props.blocked && `
    background: url(${blockIcon});
    background-size: contain;
    background-repeat: no-repeat;
  `}

  &.overlay-badge {
    margin-left: -5px;
    background-color: #747576;
  }

  @media screen and (max-width: 360px) {
    width: 18px;
    height: 18px;
    display:flex;
    align-items:center;
    justify-content:center;
  }
`
